import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./styles/tema.css";
import "./plugins/vuelidate";
import "./plugins/vue-the-mask";
import "./plugins/vuetify-money.js";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h: Vue.CreateElement) => h(App),
}).$mount("#app");
